import { ensoWidgetTheme } from '@/components/ui/theme';
import { plumeMainnetId } from '@/constants/shared';
import { AmplitudeTrackingEvent, trackAmplitudeEvent } from '@/lib/amplitude';
import SwapWidget, { SuccessDetails, WidgetState } from '@ensofinance/shortcuts-widget';
import { useState } from 'react';
import { Address, formatUnits } from 'viem';
export type EnsoSwapWidgetProps = {
  chainId?: number;
  initialTokenInAddress?: Address;
  onSwapSuccess?: () => void;
};

export const EnsoSwapWidget = ({ chainId, initialTokenInAddress, onSwapSuccess }: EnsoSwapWidgetProps) => {
  const [tokenInAddress, setTokenInAddress] = useState<Address | undefined>();
  const [tokenOutAddress, setTokenOutAddress] = useState<Address | undefined>();
  const [chainInId, setChainInId] = useState<number | undefined>();
  const [chainOutId, setChainOutId] = useState<number | undefined>();
  return (
    <SwapWidget
      apiKey={import.meta.env.VITE_ENSO_API_KEY}
      tokenIn={tokenInAddress ?? initialTokenInAddress}
      tokenOut={tokenOutAddress}
      chainId={chainInId ?? chainId ?? plumeMainnetId}
      outChainId={chainOutId ?? chainId ?? plumeMainnetId}
      onSuccess={(hash: string, swapData?: SuccessDetails) => {
        const amountOutFormatted =
          swapData?.routerData?.amountOut && swapData?.tokenOut?.decimals
            ? formatUnits(BigInt(swapData.routerData.amountOut), swapData?.tokenOut?.decimals)
            : undefined;
        const amountInFormatted =
          swapData?.amountIn && swapData?.tokenIn?.decimals
            ? formatUnits(BigInt(swapData.amountIn), swapData?.tokenIn?.decimals)
            : undefined;
        const priceImpactPercent = Number(swapData?.routerData?.priceImpact ?? 0) / 100;
        trackAmplitudeEvent(AmplitudeTrackingEvent.PortalCompletedSwap, {
          from_asset_address: tokenInAddress ?? 'unknown',
          to_asset_address: tokenOutAddress ?? 'unknown',
          provider: 'enso',
          tx_hash: hash,
          amount_in_formatted: amountInFormatted,
          amount_out_formatted: amountOutFormatted,
          total_price_impact_percent: priceImpactPercent.toString(),
        });
        onSwapSuccess?.();
      }}
      onChange={({ tokenIn, tokenOut, outChainId, chainId }: WidgetState) => {
        setTokenInAddress(tokenIn);
        setTokenOutAddress(tokenOut);
        setChainInId(chainId);
        setChainOutId(outChainId);
      }}
      notificationPlacement="bottom-start"
      themeConfig={ensoWidgetTheme}
    />
  );
};
